import { useMemo } from 'react';

const ThemePreview = ({ rowObject: theme }) => {
  const styles = useMemo(
    () => ({
      display: 'flex',
      flexFlow: 'row wrap',
      gap: '8px',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: '0 1rem',
      fontWeight: '500',
      fontFamily: theme.fontSetting['font-family'],
    }),
    [theme]
  );

  return (
    <div>
      <div style={styles}>
        <span style={{ color: theme.color.color_primary }}>Primary</span>
        <span style={{ color: theme.color.color_secondary }}>Secondary</span>
        <span style={{ color: theme.color.color_main }}>Main</span>
      </div>
      <div style={styles}>
        <span style={{ color: theme.color.color_info }}>Info</span>
        <span style={{ color: theme.color.color_warning }}>Warning</span>
        <span style={{ color: theme.color.color_success }}>Success</span>
        <span style={{ color: theme.color.color_danger }}>Danger</span>
      </div>
    </div>
  );
};

export default ThemePreview;
